import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import { Link } from 'react-router-dom';

function AccountCard({ account }) {
  return (
    <Card sx={{ minWidth: 275, mb: 2 }}>
      <CardContent>
        <Typography variant="h5" component="div">
          {account.name}
        </Typography>
        <Typography sx={{ mb: 1.5 }} color="text.secondary">
          {account.is_active ? 'Active' : 'Inactive'}
        </Typography>
        <Typography variant="body2">
          Account ID: {account.id}
        </Typography>
        <Box sx={{ mt: 2 }}>
          <Button size="small" component={Link} to={`/accounts/${account.id}`}>
            View Details
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
}

export default AccountCard;
